import { render, staticRenderFns } from "./DbDocNoHelpList.vue?vue&type=template&id=4cb99c9e&"
import script from "./DbDocNoHelpList.vue?vue&type=script&lang=js&"
export * from "./DbDocNoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports